import React, { useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import InvoiceActionFooter from "../a4Invoices/common/InvoiceActionFooter";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import PaySettleModal from "./common/PaySettleModal ";
import {
  capitalizeFirstLetter,
  loadImageDimensions,
  urlToBase64,
} from "./common/invoiceUtils";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import { useInvoiceData } from "./common/useInvoiceData";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import ReturnSaleInvoice from "./ReturnSaleInvoice";
import AxiosInstance from "../../AxiosInstance";
import handleError from "../../../constants/handleError";

const PrimeInvoice = ({
  isData,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  selectedOption,
  isActive,
  optData,
  setOptData,
}) => {
  const invoiceData = useInvoiceData({
    isData,
    onClose,
    onDataUpdate,
    onDataChange,
    optData,
    setOptData,
  });
  const {
    data,
    globalData,
    selectedTheme,
    selectedSize,
    setSelectedSize,
    qrCodeDataUrl,
    terms,
    latestVersion,
    actualPaidAmount,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,
    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,
    saleLoading,
    closeAuto,
    setCloseAuto,
    showConfirm,
    setShowConfirm,
    handleResetSale,
    saleTime,
    storeSettings,
    isUser,
    handleSelectedSale,
    handlelatestSale,
    isInterState,
    isBillReceipt,
    documentTitle,
    handleGenerateInvoice,
    handleModeConfirm,
  } = invoiceData;
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    onClose();
  };

  const handleSelectedReturnSale = async (sale) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  //prime invoice
  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING; // Starting height
    const imagePath =
      uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
    if (globalData?.salefrom?.image) {
      try {
        const logoBase64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(logoBase64);
        // 1. DRAW LOGO (Far Left)
        const maxWidth = 30;
        const maxHeight = 12;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalW = width * ratio;
        const finalH = height * ratio;

        doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(9);
        doc.setTextColor(0);
        doc.text(documentTitle, centerX, y + 3, { align: "center" });

        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.text(
          globalData?.salefrom?.title?.toUpperCase() || "",
          centerX,
          y + 8,
          { align: "center" },
        );

        doc.setFontSize(9);
        doc.setTextColor(0);

        // Invoice No Row

        const invLabel = isBillReceipt ? "Bill No." : "Invoice No.";
        const invVal = globalData?.saleno || "-";
        const invDateTime = DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(
            globalData?.saledate,
            isUser.timezone,
          ),
        ).time;
        const dateStr = `DATE: ${globalData?.saledate ? DateConverter.ISOToDisplayFormat(globalData?.saledate).date : "-"}  `;
        const timeStr = `TIME: ${invDateTime || ""}`;
        const invValW = doc.getTextWidth(invVal);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          invLabel,
          MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel),
          y + 2,
        );
        doc.setFont("Inter-Bold", "bold");
        doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
        const totalDateTimeWidth =
          doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);

        const lineStartX = MARGIN_RIGHT - totalDateTimeWidth - 1; // Adjust this number to make the line longer/shorter
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
        doc.setLineWidth(0.1);
        doc.line(lineStartX, y + 4, MARGIN_RIGHT, y + 4);

        const timeStrW = doc.getTextWidth(timeStr);
        doc.setFont("Inter-Regular", "normal");
        doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 8, {
          align: "right",
        });
        doc.text(timeStr, MARGIN_RIGHT, y + 8, { align: "right" });

        let addrY = y + finalH + 4; // Move down below logo/title area
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(9);
        //  doc.setTextColor(60, 60, 60);
        let currentTextY = addrY;
        const addrLine1 = [
          globalData?.salefrom?.addressline1,
          globalData?.salefrom?.addressline2,
        ]
          .filter(Boolean)
          .join(", ");
        const addrLine2 = [
          globalData?.salefrom?.district,
          globalData?.salefrom?.state,
          globalData?.salefrom?.pincode,
        ]
          .filter(Boolean)
          .join(", ");
        const maxWidthAdd = 60; // Adjust this value based on your layout
        const wrappedAddress1 = doc.splitTextToSize(addrLine1, maxWidthAdd);
        const wrappedAddress2 = doc.splitTextToSize(addrLine2, maxWidthAdd);

        if (addrLine1.trim()) {
          doc.text(wrappedAddress1, MARGIN_LEFT, currentTextY);
          currentTextY += wrappedAddress1.length * 4;
        }
        if (addrLine2.trim()) {
          doc.text(wrappedAddress2, MARGIN_LEFT, currentTextY);
          currentTextY += wrappedAddress2.length * 4.5;
        }
        // const contactY = addrY + 6;
        let currentX = MARGIN_LEFT;
        const phone = globalData?.salefrom?.phone;
        const gstin = globalData?.salefrom?.gstnumber;

        if (phone || gstin) {
          doc.setFont("Inter-Bold", "bold");
          doc.text("Ph:", currentX, currentTextY);
          currentX += doc.getTextWidth("Ph: ");

          doc.setFont("Inter-Regular", "normal");
          doc.text(
            `${globalData?.salefrom?.phone || ""}  `,
            currentX,
            currentTextY,
          );
          currentX += doc.getTextWidth(`${phone || ""}  `);

          doc.setFont("Inter-Bold", "bold");
          doc.text("GSTIN:", currentX, currentTextY);
          currentX += doc.getTextWidth("GSTIN: ");

          doc.setFont("Inter-Regular", "normal");
          doc.text(`${gstin || ""}`, currentX, currentTextY);
          // doc.text(contactLine, MARGIN_LEFT, addrY + 6);
        }
        y = currentTextY + 2;
      } catch (e) {
        console.warn("Header layout failed", e);
        y += 15;
      }
    }

    y += 1;

    if (globalData?.saleto && optData.isCustomerDisplay) {
      const hasShipping =
        globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2; // adjust key if needed

      let rowHeight = 6;
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      );
      doc.setLineWidth(0.2);

      const totalBoxWidth = MARGIN_RIGHT - MARGIN_LEFT;
      const col1EndX = hasShipping
        ? MARGIN_LEFT + totalBoxWidth * 0.39
        : MARGIN_LEFT + totalBoxWidth * 0.75;
      const col2EndX = MARGIN_LEFT + totalBoxWidth * 0.76;
      const rightSectionStart = hasShipping ? col2EndX + 2 : col2EndX;

      // --- LEFT: Customer Details ---
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Customer Details :", MARGIN_LEFT + 2, y + 4);

      doc.setFontSize(8);
      doc.setFont("Inter-Regular", "normal");
      doc.text(globalData?.saleto?.name || "", MARGIN_LEFT + 2, y + 8);
      rowHeight += 4;

      const fullAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
      ]
        .filter(Boolean)
        .join(", ");
      const pinCode = globalData?.saleto?.pincode
        ? ` - ${globalData?.saleto.pincode}`
        : "";

      const col1MaxWidth = col1EndX - MARGIN_LEFT - 4;
      if (fullAddress || pinCode) {
        doc.setFontSize(9);
        const wrappedAddr = doc.splitTextToSize(
          fullAddress + pinCode,
          col1MaxWidth,
        );
        doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 12);
        rowHeight += wrappedAddr.length * 3.5;
      }

      // --- MIDDLE: Shipping Details ---
      let shippingRowHeight = 6;
      if (hasShipping) {
        const shipping = globalData.saleto?.shippingAddress;
        const col2StartX = col1EndX + 2;
        const col2MaxWidth = col2EndX - col1EndX - 4;

        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(9);
        doc.text("Shipping Details :", col2StartX, y + 4);

        doc.setFontSize(8);
        doc.setFont("Inter-Regular", "normal");
        const shipAddress = [
          shipping?.addressline1,
          shipping?.addressline2,
          shipping?.district,
          shipping?.state,
        ]
          .filter(Boolean)
          .join(", ");
        const shipPin = shipping?.pincode ? ` - ${shipping.pincode}` : "";

        if (shipAddress || shipPin) {
          doc.setFontSize(9);
          const wrappedShip = doc.splitTextToSize(
            shipAddress + shipPin,
            col2MaxWidth,
          );
          doc.text(wrappedShip, col2StartX, y + 8);
          shippingRowHeight += wrappedShip.length * 3.5;
        }

        rowHeight = Math.max(rowHeight, shippingRowHeight);
      }
      let detailY = y + 4;
      // --- RIGHT: Ph / GSTIN ---
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      const phLabel = "Ph: ";
      doc.text(phLabel, rightSectionStart, detailY);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        globalData?.saleto?.phone || "",
        rightSectionStart + doc.getTextWidth(phLabel),
        detailY,
      );
      detailY += 5;
      doc.setFont("Inter-Bold", "bold");
      const gstLabel = "GSTIN: ";
      doc.text(gstLabel, rightSectionStart, detailY);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        globalData?.saleto?.gstnumber || "",
        rightSectionStart + doc.getTextWidth(gstLabel),
        detailY,
      );
      if (globalData?.saleto?.pannumber) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const panLabel = "PAN: ";
        doc.text(panLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.pannumber || "",
          rightSectionStart + doc.getTextWidth(panLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.fssai) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const fassiLabel = "FASSI: ";
        doc.text(fassiLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.fssai || "",
          rightSectionStart + doc.getTextWidth(fassiLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.cinnumber) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const cinLabel = "CIN: ";
        doc.text(cinLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.cinnumber || "",
          rightSectionStart + doc.getTextWidth(cinLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.referenceid) {
        detailY += 5;
        doc.setFont("Inter-Regular", "normal");
        const refidLabel = "Reference No: ";
        doc.text(refidLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.referenceid || "",
          rightSectionStart + doc.getTextWidth(refidLabel),
          detailY,
        );
        detailY += 5;
      }
      rowHeight = Math.max(rowHeight, detailY - y);
      // Draw dividers
      doc.line(col1EndX, y, col1EndX, y + rowHeight);
      if (hasShipping) {
        doc.line(col2EndX, y, col2EndX, y + rowHeight);
      }

      doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
      y += rowHeight;
    }
    /* -------------------------------------------------
        PRODUCT TABLE1
     ------------------------------------------------- */
    const rowCount = globalData?.saleitems?.length;

    const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace =
      rowCount > 0 && rowCount <= 5
        ? targetTotalHeight - rowCount * standardHeight
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: "avoid",
      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: PADDING,
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 1.5,
        valign: "top",
        lineWidth: 0, // No default borders
      },
      headStyles: {
        font: "Inter-Bold",
        //  fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight),
      },
      head: [["#", "Item", "Rate", "Qty", "Taxable Val", "Tax Amt", "Amount"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}`
          : it.title,

        `₹${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${it.lineTotalBasePrice}`,
        `₹${it.lineTotalTaxAmount}`,

        `₹${it.lineGrandTotal}`,
      ]),
      // body:repeatedBody,
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 15, halign: "center" },
        4: { cellWidth: 22, halign: "right" },
        5: { cellWidth: 20, halign: "right" },
        6: { cellWidth: 22, halign: "right" },
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
          if (
            colId === 2 ||
            colId === 4 ||
            colId === 5 ||
            colId === 6 ||
            colId === 7
          )
            data.cell.styles.halign = "right";
        }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1,
            right: 0.1,
            top: 0,
            bottom: 0,
          };
          data.cell.styles.lineColor = selectedTheme?.templateTheme
            ?.borderColor || [200, 200, 200]; // Black vertical lines
          if (data.row.index === rowCount - 1) {
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });

    let finalY = doc.lastAutoTable.finalY;
    const footerHeight = 45; // Increased to accommodate the stacked boxes

    if (finalY + footerHeight > pageH - PADDING) {
      doc.addPage();
      finalY = PADDING;
    }

    const borderColor = selectedTheme?.templateTheme?.borderColor || [
      200, 200, 200,
    ];
    doc.setDrawColor(borderColor[0], borderColor[1], borderColor[2]);
    doc.setLineWidth(0.1);

    // X-coordinate for the vertical divider (aligns with the last column)
    const dividerX = MARGIN_RIGHT - 64;
    const boxWidth = MARGIN_RIGHT - PADDING;
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;

    // --- BOX 1: TOTALS AND TAXES ---
    const box1Height = isInterState ? 12 : 18;
    doc.rect(PADDING, finalY, boxWidth, box1Height); // Outer border
    doc.line(dividerX, finalY, dividerX, finalY + box1Height); // Vertical divider

    // Box 1 Content: In Words
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("In Words:", PADDING + 2, finalY + 5);
    doc.setFont("Inter-Regular", "normal");
    const words = globalData?.amountinwords || "";
    doc.text(words, PADDING + 18, finalY + 5, {
      maxWidth: dividerX - PADDING - 17,
    });

    const taxSummary = [
      { label: "TOTAL", value: globalData?.grandtotal },

      ...(isInterState
        ? [{ label: "IGST", value: globalData?.igstamount || 0 }]
        : [
            { label: "CGST", value: globalData?.cgstamount || 0 },
            { label: "SGST", value: globalData?.sgstamount || 0 },
          ]),
    ];

    taxSummary.forEach((item, i) => {
      let itemY = finalY + 4 + i * 6;
      doc.text(item.label, dividerX + 2, itemY);
      doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
      if (i < taxSummary.length - 1) {
        doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2); // Mini horizontal lines
      }
    });
    const box2Y = finalY + box1Height;
    const box2Height = 12;
    doc.rect(PADDING, box2Y, boxWidth, box2Height); // Outer border
    doc.line(dividerX, box2Y, dividerX, box2Y + box2Height); // Vertical divider

    if (optData?.isPayment) {
      const paymentData = [
        { label: "Cash", val: globalData?.cashPaid },
        { label: "Card", val: globalData?.cardPaid },
        { label: "UPI", val: globalData?.upiPaid },
        { label: "Online", val: globalData?.onlinePaid },
      ].filter((p) => p.val > 0);

      // --- BOX 2: PAYMENTS AND PAYABLES ---

      // Box 2 Content: Payment Methods (Left Side)
      let payX = PADDING + 2;

      paymentData.forEach((pay, index) => {
        const col = index % 2; // 0 or 1 (2 per row)
        const row = Math.floor(index / 2); // row number
        const colWidth = 50; // horizontal spacing
        const rowHeight = 5;
        const x = payX + col * colWidth;
        const y = box2Y + 4 + row * rowHeight;
        const displayVal = `₹${pay.val}`;
        doc.setFont("Inter-Bold", "bold");
        doc.text(displayVal, x, y);

        const valWidth = doc.getTextWidth(displayVal);
        doc.setFont("Inter-Regular", "normal");
        doc.text(` Paid via ${pay.label}`, x + valWidth + 1, y);
      });
    }
    const paidamount =
      (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

    // Box 2 Content: Payables (Right Side)
    const payableSummary = [
      { label: "Amount Payable", value: globalData?.balanceDue, isBold: true },
      {
        label: "Amount Paid",
        value: `${paidamount.toFixed(2)}`,
        isBold: false,
      },
    ];

    payableSummary.forEach((item, i) => {
      let itemY = box2Y + 4 + i * 6;
      const textColor = selectedTheme?.templateTheme?.foregroundColor;
      if (i === 0) {
        const themeColor =
          selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";
        doc.setFillColor(themeColor);
        doc.rect(
          dividerX + 0.5,
          itemY - 4,
          MARGIN_RIGHT - dividerX - 1,
          6,
          "F",
        );
        // Draw the bottom separator line
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(dividerX, itemY - 4, MARGIN_RIGHT, itemY - 4);
        doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2);
      }
      if (item.isBold) {
        doc.setTextColor(textColor);
        doc.setFont("Inter-Bold", "bold");
      } else {
        doc.setTextColor(0, 0, 0); // black
        doc.setFont("Inter-Regular", "normal");
      }
      doc.text(item.label, dividerX + 2, itemY);
      doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
    });

    // ==============================
    // Bank + QR + Signature Section
    // ==============================

    let sectionY = box2Y + 4 + payableSummary.length * 6 + 4;

    const leftX = PADDING;
    const qrSize = 28;
    const qrX = (pageW - qrSize) / 2;
    const rightX = MARGIN_RIGHT;

    // ---------- Calculate Heights ----------
    let bankHeight = 0;

    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      bankHeight = 5; // title

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName)
        bankHeight += 4;

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo)
        bankHeight += 4;

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) bankHeight += 4;

      if (storeSettings?.paymentSettings?.upiId) bankHeight += 4;
    }

    let qrHeight = qrCodeDataUrl && optData?.isBankDetails ? qrSize : 0;

    let signHeight = storeSettings?.invoiceSettings?.signature ? 22 : 14;

    // Take tallest block
    const blockHeight = Math.max(bankHeight, qrHeight, signHeight);

    // Page break if required
    if (sectionY + blockHeight > pageH - PADDING) {
      doc.addPage();
      sectionY = PADDING;
    }

    // ==================================
    // Bank Details
    // ==================================

    let bankY = sectionY;

    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);
      bankY += 5;
      const bankDetails = [];
      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18;

      bankDetails.forEach((item) => {
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(`${item.label} :`, leftX, bankY);
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);
    }

    if (qrCodeDataUrl && optData?.isBankDetails) {
      doc.addImage(qrCodeDataUrl, "PNG", qrX, sectionY - 3, qrSize, qrSize);
    }

    let signBottom = sectionY;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);

    doc.text(`For ${globalData?.salefrom?.title}`, rightX, sectionY, {
      align: "right",
    });

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;

        const base64 = await urlToBase64(signimg);

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 25;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);

        const imgW = width * ratio;
        const imgH = height * ratio;

        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          rightX - imgW,
          sectionY + 4,
          imgW,
          imgH,
        );

        signBottom = sectionY + 4 + imgH;
      } catch {}
    } else {
      doc.line(rightX - 30, sectionY + 10, rightX, sectionY + 10);

      signBottom = sectionY + 10;
    }

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory", rightX, signBottom + 5, {
      align: "right",
    });

    signBottom += 5;

    const sectionEndY = Math.max(bankY, sectionY + qrHeight, signBottom);

    if (optData?.isRemark && globalData?.remark) {
      let remarkStartY = sectionEndY + 3;

      const remarkLines = doc.splitTextToSize(
        globalData.remark.charAt(0).toUpperCase() + globalData.remark.slice(1),
        pageW - PADDING * 2 - 4,
      );

      const remarkHeight = 4 + remarkLines.length * 4;

      // Page break if needed
      if (remarkStartY + remarkHeight > pageH - PADDING) {
        doc.addPage();
        remarkStartY = PADDING;
      }

      // Heading
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Remark", PADDING, remarkStartY);

      // Border box
      const boxY = remarkStartY + 3;
      doc.setDrawColor(borderColor);
      // doc.rect(
      //   PADDING,
      //   boxY,
      //   pageW - PADDING * 2,
      //   remarkHeight,
      //   "S"
      // );

      // Remark text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);

      let textY = boxY + 2;

      remarkLines.forEach((line) => {
        if (textY > pageH - PADDING) {
          doc.addPage();
          textY = PADDING;
        }
        doc.text(line, PADDING, textY);
        textY += 4;
      });

      // Move Terms below the remark
      sectionY = boxY + remarkHeight;
    } else {
      sectionY = sectionEndY;
    }
    let termsStartY = sectionY + 3;

    // 👉 Estimate terms height
    const termLines = doc.splitTextToSize(terms || "", pageW - PADDING * 2);
    const termsHeight = 10 + termLines.length * 4;

    // 👉 Page break BEFORE rendering
    if (termsStartY + termsHeight > pageH - PADDING) {
      doc.addPage();
      termsStartY = PADDING;
    }

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", PADDING, termsStartY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);

      let currentY = termsStartY + 5;
      const termLines1 = doc.splitTextToSize(terms, pageW - PADDING * 2);

      termLines1.forEach((line) => {
        if (currentY > pageH - PADDING) {
          doc.addPage();
          currentY = PADDING;
        }
        doc.text(line, PADDING, currentY);
        currentY += 5;
      });

      termsStartY = currentY;
    }

    // 👉 Row 3 (Branding)
    if (storeSettings?.negobillBranding) {
      let brandingY = termsStartY + 6;

      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(10);

      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);
      doc.text(normalText, MARGIN_LEFT, brandingY);

      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, MARGIN_LEFT + normalW, brandingY);
    }
    return doc;
  };

  const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING; // Starting height
    const imagePath =
      uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
    if (globalData?.salefrom?.image) {
      try {
        const logoBase64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(logoBase64);
        // 1. DRAW LOGO (Far Left)
        const maxWidth = 30;
        const maxHeight = 12;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalW = width * ratio;
        const finalH = height * ratio;

        doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(9);
        doc.setTextColor(0);
        doc.text("BILL RECEIPT", centerX, y + 3, { align: "center" });

        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.text(
          globalData?.salefrom?.title?.toUpperCase() || "",
          centerX,
          y + 8,
          { align: "center" },
        );

        doc.setFontSize(9);
        doc.setTextColor(0);

        // Invoice No Row

        const invLabel = "Bill No. ";
        const invVal = globalData?.saleno || "-";
        const invDateTime = DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(
            globalData?.saledate,
            isUser.timezone,
          ),
        ).time;
        const dateStr = `DATE: ${globalData?.saledate ? DateConverter.ISOToDisplayFormat(globalData?.saledate).date : "-"}  `;
        const timeStr = `TIME: ${invDateTime || ""}`;
        const invValW = doc.getTextWidth(invVal);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          invLabel,
          MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel),
          y + 2,
        );
        doc.setFont("Inter-Bold", "bold");
        doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
        const totalDateTimeWidth =
          doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);

        const lineStartX = MARGIN_RIGHT - totalDateTimeWidth - 1; // Adjust this number to make the line longer/shorter
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
        doc.setLineWidth(0.1);
        doc.line(lineStartX, y + 4, MARGIN_RIGHT, y + 4);

        const timeStrW = doc.getTextWidth(timeStr);
        doc.setFont("Inter-Regular", "normal");
        doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 8, {
          align: "right",
        });
        doc.text(timeStr, MARGIN_RIGHT, y + 8, { align: "right" });

        let addrY = y + finalH + 4; // Move down below logo/title area
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(9);
        //  doc.setTextColor(60, 60, 60);
        let currentTextY = addrY;
        const addrLine1 = [
          globalData?.salefrom?.addressline1,
          globalData?.salefrom?.addressline2,
        ]
          .filter(Boolean)
          .join(", ");
        const addrLine2 = [
          globalData?.salefrom?.district,
          globalData?.salefrom?.state,
          globalData?.salefrom?.pincode,
        ]
          .filter(Boolean)
          .join(", ");
        const maxWidthAdd = 60; // Adjust this value based on your layout
        const wrappedAddress1 = doc.splitTextToSize(addrLine1, maxWidthAdd);
        const wrappedAddress2 = doc.splitTextToSize(addrLine2, maxWidthAdd);

        if (addrLine1.trim()) {
          doc.text(wrappedAddress1, MARGIN_LEFT, currentTextY);
          currentTextY += wrappedAddress1.length * 4;
        }
        if (addrLine2.trim()) {
          doc.text(wrappedAddress2, MARGIN_LEFT, currentTextY);
          currentTextY += wrappedAddress2.length * 4.5;
        }
        // const contactY = addrY + 6;
        let currentX = MARGIN_LEFT;
        const phone = globalData?.salefrom?.phone;
        const gstin = globalData?.salefrom?.gstnumber;

        if (phone || gstin) {
          doc.setFont("Inter-Bold", "bold");
          doc.text("Ph:", currentX, currentTextY);
          currentX += doc.getTextWidth("Ph: ");

          doc.setFont("Inter-Regular", "normal");
          doc.text(
            `${globalData?.salefrom?.phone || ""}  `,
            currentX,
            currentTextY,
          );
          currentX += doc.getTextWidth(`${phone || ""}  `);
        }
        y = currentTextY + 2;
      } catch (e) {
        console.warn("Header layout failed", e);
        y += 15;
      }
    }

    y += 1;

    if (globalData?.saleto && optData.isCustomerDisplay) {
      const hasShipping =
        globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2; // adjust key if needed

      let rowHeight = 6;
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      );
      doc.setLineWidth(0.2);

      const totalBoxWidth = MARGIN_RIGHT - MARGIN_LEFT;
      const col1EndX = hasShipping
        ? MARGIN_LEFT + totalBoxWidth * 0.39
        : MARGIN_LEFT + totalBoxWidth * 0.75;
      const col2EndX = MARGIN_LEFT + totalBoxWidth * 0.76;
      const rightSectionStart = hasShipping ? col2EndX + 2 : col2EndX;

      // --- LEFT: Customer Details ---
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Customer Details :", MARGIN_LEFT + 2, y + 4);

      doc.setFontSize(8);
      doc.setFont("Inter-Regular", "normal");
      doc.text(globalData?.saleto?.name || "", MARGIN_LEFT + 2, y + 8);
      rowHeight += 4;

      const fullAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
      ]
        .filter(Boolean)
        .join(", ");
      const pinCode = globalData?.saleto?.pincode
        ? ` - ${globalData?.saleto.pincode}`
        : "";

      const col1MaxWidth = col1EndX - MARGIN_LEFT - 4;
      if (fullAddress || pinCode) {
        doc.setFontSize(9);
        const wrappedAddr = doc.splitTextToSize(
          fullAddress + pinCode,
          col1MaxWidth,
        );
        doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 12);
        rowHeight += wrappedAddr.length * 3.5;
      }

      // --- MIDDLE: Shipping Details ---
      let shippingRowHeight = 6;
      if (hasShipping) {
        const shipping = globalData.saleto?.shippingAddress;
        const col2StartX = col1EndX + 2;
        const col2MaxWidth = col2EndX - col1EndX - 4;

        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(9);
        doc.text("Shipping Details :", col2StartX, y + 4);

        doc.setFontSize(8);
        doc.setFont("Inter-Regular", "normal");
        const shipAddress = [
          shipping?.addressline1,
          shipping?.addressline2,
          shipping?.district,
          shipping?.state,
        ]
          .filter(Boolean)
          .join(", ");
        const shipPin = shipping?.pincode ? ` - ${shipping.pincode}` : "";

        if (shipAddress || shipPin) {
          doc.setFontSize(9);
          const wrappedShip = doc.splitTextToSize(
            shipAddress + shipPin,
            col2MaxWidth,
          );
          doc.text(wrappedShip, col2StartX, y + 8);
          shippingRowHeight += wrappedShip.length * 3.5;
        }

        rowHeight = Math.max(rowHeight, shippingRowHeight);
      }
      let detailY = y + 4;
      // --- RIGHT: Ph / GSTIN ---
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      const phLabel = "Ph: ";
      doc.text(phLabel, rightSectionStart, detailY);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        globalData?.saleto?.phone || "",
        rightSectionStart + doc.getTextWidth(phLabel),
        detailY,
      );
      detailY += 5;
      doc.setFont("Inter-Bold", "bold");
      const gstLabel = "GSTIN: ";
      doc.text(gstLabel, rightSectionStart, detailY);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        globalData?.saleto?.gstnumber || "",
        rightSectionStart + doc.getTextWidth(gstLabel),
        detailY,
      );
      if (globalData?.saleto?.pannumber) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const panLabel = "PAN: ";
        doc.text(panLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.pannumber || "",
          rightSectionStart + doc.getTextWidth(panLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.fssai) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const fassiLabel = "FASSI: ";
        doc.text(fassiLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.fssai || "",
          rightSectionStart + doc.getTextWidth(fassiLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.cinnumber) {
        detailY += 5;
        doc.setFont("Inter-Bold", "bold");
        const cinLabel = "CIN: ";
        doc.text(cinLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.cinnumber || "",
          rightSectionStart + doc.getTextWidth(cinLabel),
          detailY,
        );
      }
      if (globalData?.saleto?.referenceid) {
        detailY += 5;
        doc.setFont("Inter-Regular", "normal");
        const refidLabel = "Reference No: ";
        doc.text(refidLabel, rightSectionStart, detailY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          globalData?.saleto?.referenceid || "",
          rightSectionStart + doc.getTextWidth(refidLabel),
          detailY,
        );
        detailY += 5;
      }
      rowHeight = Math.max(rowHeight, detailY - y);
      // Draw dividers
      doc.line(col1EndX, y, col1EndX, y + rowHeight);
      if (hasShipping) {
        doc.line(col2EndX, y, col2EndX, y + rowHeight);
      }

      doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
      y += rowHeight;
    }
    /* -------------------------------------------------
        PRODUCT TABLE1
     ------------------------------------------------- */
    const rowCount = globalData?.saleitems?.length;

    const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace =
      rowCount > 0 && rowCount <= 5
        ? targetTotalHeight - rowCount * standardHeight
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: "avoid",
      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: PADDING,
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 1.5,
        valign: "top",
        lineWidth: 0, // No default borders
      },
      headStyles: {
        font: "Inter-Bold",
        //  fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight),
      },
      head: [["#", "Item", "Rate", "Qty", "Amount"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}`
          : it.title,

        `₹${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${it.lineGrandTotal}`,
      ]),
      // body:repeatedBody,
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },
        2: { cellWidth: 22, halign: "right" },
        3: { cellWidth: 15, halign: "center" },
        4: { cellWidth: 22, halign: "right" },
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 4 || colId === 5 || colId === 6)
            data.cell.styles.halign = "right";
        }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1,
            right: 0.1,
            top: 0,
            bottom: 0,
          };
          data.cell.styles.lineColor = selectedTheme?.templateTheme
            ?.borderColor || [200, 200, 200]; // Black vertical lines
          if (data.row.index === rowCount - 1) {
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });

    let finalY = doc.lastAutoTable.finalY;
    const footerHeight = 25; // Increased to accommodate the stacked boxes

    if (finalY + footerHeight > pageH - PADDING) {
      doc.addPage();
      finalY = PADDING;
    }

    const borderColor = selectedTheme?.templateTheme?.borderColor || [
      200, 200, 200,
    ];
    doc.setDrawColor(borderColor[0], borderColor[1], borderColor[2]);
    doc.setLineWidth(0.1);

    // X-coordinate for the vertical divider (aligns with the last column)
    const dividerX = MARGIN_RIGHT - 59;
    const boxWidth = MARGIN_RIGHT - PADDING;

    // --- BOX 1: TOTALS AND TAXES ---
    const box1Height = 6;
    doc.rect(PADDING, finalY, boxWidth, box1Height); // Outer border
    doc.line(dividerX, finalY, dividerX, finalY + box1Height); // Vertical divider

    // Box 1 Content: In Words
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("In Words:", PADDING + 2, finalY + 4);
    doc.setFont("Inter-Regular", "normal");
    const words = globalData?.amountinwords || "";
    doc.text(words, PADDING + 18, finalY + 4, {
      maxWidth: dividerX - PADDING - 17,
    });

    const taxSummary = [{ label: "TOTAL", value: globalData?.grandtotal }];

    taxSummary.forEach((item, i) => {
      let itemY = finalY + 4 + i * 6;
      doc.text(item.label, dividerX + 2, itemY);
      doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
    });
    const box2Y = finalY + box1Height;
    const box2Height = 12;
    doc.rect(PADDING, box2Y, boxWidth, box2Height); // Outer border
    doc.line(dividerX, box2Y, dividerX, box2Y + box2Height); // Vertical divider

    if (optData?.isPayment) {
      const paymentData = [
        { label: "Cash", val: globalData?.cashPaid },
        { label: "Card", val: globalData?.cardPaid },
        { label: "UPI", val: globalData?.upiPaid },
        { label: "Online", val: globalData?.onlinePaid },
      ].filter((p) => p.val > 0);
      // --- BOX 2: PAYMENTS AND PAYABLES ---

      // Box 2 Content: Payment Methods (Left Side)
      let payX = PADDING + 2;

      paymentData.forEach((pay, index) => {
        const col = index % 2; // 0 or 1 (2 per row)
        const row = Math.floor(index / 2); // row number
        const colWidth = 50; // horizontal spacing
        const rowHeight = 5;
        const x = payX + col * colWidth;
        const y = box2Y + 4 + row * rowHeight;
        const displayVal = `₹${pay.val}`;
        doc.setFont("Inter-Bold", "bold");
        doc.text(displayVal, x, y);

        const valWidth = doc.getTextWidth(displayVal);
        doc.setFont("Inter-Regular", "normal");
        doc.text(` Paid via ${pay.label}`, x + valWidth + 1, y);
      });
    }
    const paidamount =
      (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

    // Box 2 Content: Payables (Right Side)
    const payableSummary = [
      { label: "Amount Payable", value: globalData?.balanceDue, isBold: true },
      {
        label: "Amount Paid",
        value: `${paidamount.toFixed(2)}`,
        isBold: false,
      },
    ];

    payableSummary.forEach((item, i) => {
      let itemY = box2Y + 4 + i * 6;
      const textColor = selectedTheme?.templateTheme?.foregroundColor;
      if (i === 0) {
        const themeColor =
          selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";

        doc.setFillColor(themeColor);
        doc.setTextColor(textColor);
        doc.rect(
          dividerX + 0.5,
          itemY - 4,
          MARGIN_RIGHT - dividerX - 1,
          6,
          "F",
        );
        // Draw the bottom separator line
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(dividerX, itemY - 4, MARGIN_RIGHT, itemY - 4);
        doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2);
      }
      if (item.isBold) {
        doc.setTextColor(textColor);
        doc.setFont("Inter-Bold", "bold");
      } else {
        doc.setTextColor(0, 0, 0); // black
        doc.setFont("Inter-Regular", "normal");
      }

      doc.text(item.label, dividerX + 2, itemY);
      doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
    });

    let sectionY = box2Y + 4 + payableSummary.length * 6 + 4;

    const leftX = PADDING;
    const qrSize = 28;
    const qrX = (pageW - qrSize) / 2;
    const rightX = MARGIN_RIGHT;

    // ---------- Calculate Heights ----------
    let bankHeight = 0;

    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      bankHeight = 5; // title

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName)
        bankHeight += 4;

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo)
        bankHeight += 4;

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) bankHeight += 4;

      if (storeSettings?.paymentSettings?.upiId) bankHeight += 4;
    }

    let qrHeight = qrCodeDataUrl && optData?.isBankDetails ? qrSize : 0;

    let signHeight = storeSettings?.invoiceSettings?.signature ? 22 : 14;

    // Take tallest block
    const blockHeight = Math.max(bankHeight, qrHeight, signHeight);

    // Page break if required
    if (sectionY + blockHeight > pageH - PADDING) {
      doc.addPage();
      sectionY = PADDING;
    }

    // ==================================
    // Bank Details
    // ==================================

    let bankY = sectionY;
    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);
      bankY += 5;
      const bankDetails = [];
      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18;

      bankDetails.forEach((item) => {
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(`${item.label} :`, leftX, bankY);
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);
    }
    if (qrCodeDataUrl && optData?.isBankDetails) {
      doc.addImage(qrCodeDataUrl, "PNG", qrX, sectionY - 3, qrSize, qrSize);
    }

    let signBottom = sectionY;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);

    doc.text(`For ${globalData?.salefrom?.title}`, rightX, sectionY, {
      align: "right",
    });

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;

        const base64 = await urlToBase64(signimg);

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 25;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);

        const imgW = width * ratio;
        const imgH = height * ratio;

        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          rightX - imgW,
          sectionY + 4,
          imgW,
          imgH,
        );

        signBottom = sectionY + 4 + imgH;
      } catch {}
    } else {
      doc.line(rightX - 30, sectionY + 10, rightX, sectionY + 10);

      signBottom = sectionY + 10;
    }

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory", rightX, signBottom + 5, {
      align: "right",
    });

    signBottom += 5;

    const sectionEndY = Math.max(bankY, sectionY + qrHeight, signBottom);

    // 👉 Remark
    // let remarkStartY = signatureY + 4;

    if (optData?.isRemark && globalData?.remark) {
      let remarkStartY = sectionEndY + 3;

      const remarkLines = doc.splitTextToSize(
        globalData.remark.charAt(0).toUpperCase() + globalData.remark.slice(1),
        pageW - PADDING * 2 - 4,
      );

      const remarkHeight = 4 + remarkLines.length * 4;

      // Page break if needed
      if (remarkStartY + remarkHeight > pageH - PADDING) {
        doc.addPage();
        remarkStartY = PADDING;
      }

      // Heading
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Remark", PADDING, remarkStartY);

      // Border box
      const boxY = remarkStartY + 3;
      doc.setDrawColor(borderColor);
      // Remark text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);

      let textY = boxY + 2;

      remarkLines.forEach((line) => {
        if (textY > pageH - PADDING) {
          doc.addPage();
          textY = PADDING;
        }
        doc.text(line, PADDING, textY);
        textY += 4;
      });

      // Move Terms below the remark
      sectionY = boxY + remarkHeight;
    } else {
      sectionY = sectionEndY;
    }
    // 👉 Row 2 (Terms)
    let termsStartY = sectionY + 3;

    const termLines = doc.splitTextToSize(terms || "", pageW - PADDING * 2);
    const termsHeight = 10 + termLines.length * 4;

    // 👉 Page break BEFORE rendering
    if (termsStartY + termsHeight > pageH - PADDING) {
      doc.addPage();
      termsStartY = PADDING + 1;
    }

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", PADDING, termsStartY);
      doc.setFont("Inter-Regular", "normal");
      const termLines1 = doc.splitTextToSize(terms, pageW - PADDING * 2);

      let currentY = termsStartY + 5;

      termLines1.forEach((line) => {
        if (currentY > pageH - PADDING) {
          doc.addPage();
          currentY = PADDING;
        }

        doc.text(line, PADDING, currentY);
        currentY += 5;
      });

      termsStartY = currentY;
    }

    // 👉 Row 3 (Branding)
    if (storeSettings?.negobillBranding) {
      let brandingY = termsStartY + 6;

      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(10);

      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);
      doc.text(normalText, MARGIN_LEFT, brandingY);

      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, MARGIN_LEFT + normalW, brandingY);
    }
    return doc;
  };

  const items = globalData?.saleitems || [];

  let repeatedBody = [];

  for (let r = 0; r < 15; r++) {
    items.forEach((it, i) => {
      repeatedBody.push([
        repeatedBody.length + 1, // continuous serial number
        it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}`
          : it.title,
        `₹${it.baseprice}`,
        it.quantity,
        `₹${it.lineTotalBasePrice}`,
        `₹${it.lineTotalTaxAmount}`,
        `₹${it.lineGrandTotal}`,
      ]);
    });
  }
  if (isReturnView) {
    return (
      <ReturnSaleInvoice
        isData={returnData} // This is the updated return sale data loaded by your hook
        selectedOption={selectedOption}
        onClose={handleClose}
        saleId={isData?._id}
        onDataUpdate={onDataUpdate}
        onDataChange={onDataChange}
        isActive={isActive}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={data}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        generateInvoice1={generateInvoice1}
        generateBill1={generateBill1}
        onClose={handleClose}
        {...invoiceData}
      >
        <InvoiceToggleActionCard
          optData={optData}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              width: "100%",
              maxHeight: "100%",
              paddingRight: "8px",
              paddingLeft: "8px",
            }}
          >
            {globalData?.salemode === "INVOICE" || isBillReceipt ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-3">
                          <div className="d-flex pb-1">
                            <div style={{ maxWidth: "16rem" }}>
                              <div>
                                {globalData?.salefrom?.image && (
                                  <img
                                    src={
                                      uRLs.IMAGE_URL +
                                      "profile/" +
                                      globalData?.salefrom?.image
                                    }
                                    className="img-rounded logo mb-0 obj-contain"
                                    height="45"
                                    width="100"
                                  />
                                )}
                              </div>

                              <div className="font-12">
                                {globalData?.salefrom?.addressline1}{" "}
                                {globalData?.salefrom?.addressline2}
                              </div>
                              <div className="font-12">
                                {globalData?.salefrom?.district}{" "}
                                {globalData?.salefrom?.state || ""}{" "}
                                {globalData?.salefrom?.pincode || ""}
                              </div>
                              <div className="font-12">
                                <span className="fw-bold">Ph:</span>{" "}
                                {globalData?.salefrom?.phone}{" "}
                                <span className="fw-bold">GSTIN:</span>{" "}
                                {globalData?.salefrom?.gstnumber}
                              </div>
                            </div>

                            <div style={{ flex: "1" }} className="text-center">
                              <div
                                style={{
                                  fontSize: "10px",
                                  color: "#555",
                                }}
                              >
                                {documentTitle}
                              </div>
                              <div
                                className="font012 mt-0"
                                style={{
                                  fontWeight: "800",
                                  textTransform: "uppercase",
                                  lineHeight: "1",
                                }}
                              >
                                {globalData?.salefrom?.title || "COMPANY NAME"}
                              </div>
                            </div>

                            <div style={{ flex: "1" }} className="text-end">
                              <div className="text-end d-inline-block">
                                <div
                                  className=" font-12 mb-0"
                                  style={{
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {isBillReceipt ? "Bill No." : "Invoice No."}
                                  <span className="fw-bold">
                                    {" "}
                                    {globalData?.saleno}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-end font-12">
                                  {/* <span>DATE: {saleTime?.date}</span> */}
                                  <span> DATE: {saleTime?.date}</span>
                                  <span className="ms-3">
                                    TIME:{saleTime?.time}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {globalData?.saleto && optData.isCustomerDisplay && (
                            <div
                              className="d-flex "
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                style={{
                                  flex: "1",
                                  padding: "5px",
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <span className="fw-bold font-12">
                                  Customer Details :
                                </span>
                                <div className="font-12 ">
                                  {globalData?.saleto?.name}
                                </div>
                                <div className="font-12">
                                  {" "}
                                  {globalData?.saleto?.addressline1 &&
                                    `${globalData?.saleto?.addressline1}, `}
                                  {globalData?.saleto?.addressline2 &&
                                    `${globalData?.saleto?.addressline2}, `}
                                  {globalData?.saleto?.district &&
                                    `${globalData?.saleto?.district}, `}
                                  {globalData?.saleto?.pincode &&
                                    ` - ${globalData?.saleto?.pincode}`}
                                </div>
                              </div>
                              {globalData?.saleto?.shippingAddress
                                ?.addressline1 &&
                                globalData?.saleto?.shippingAddress
                                  ?.addressline1 && (
                                  <div
                                    style={{
                                      flex: "1",
                                      padding: "5px",
                                      borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    <span className="fw-bold font-12">
                                      shipping Details:
                                    </span>
                                    <div className="font-12 ">
                                      {
                                        globalData?.saleto?.shippingAddress
                                          ?.name
                                      }
                                    </div>
                                    <div className="font-12">
                                      {" "}
                                      {globalData?.saleto?.shippingAddress
                                        ?.addressline1 &&
                                        `${globalData?.saleto?.shippingAddress?.addressline1}, `}
                                      {globalData?.saleto?.shippingAddress
                                        ?.addressline2 &&
                                        `${globalData?.saleto?.shippingAddress?.addressline2}, `}
                                      {globalData?.saleto?.shippingAddress
                                        ?.district &&
                                        `${globalData?.saleto?.shippingAddress?.district}, `}
                                      {globalData?.saleto?.shippingAddress
                                        ?.pincode &&
                                        ` - ${globalData?.saleto?.shippingAddress?.pincode}`}
                                    </div>
                                  </div>
                                )}
                              <div
                                style={{
                                  width: "200px",
                                  padding: "5px",
                                  WebkitFontSmoothing: "antialiased",
                                  textRendering: "optimizeLegibility",
                                }}
                              >
                                <div className="font-12">
                                  <span className="fw-bold">Ph:</span>{" "}
                                  {globalData?.saleto?.phone || ""}
                                </div>
                                <div className=" font-12">
                                  {" "}
                                  <span className="fw-bold">GSTIN:</span>{" "}
                                  {globalData?.saleto?.gstnumber || ""}
                                </div>
                                {globalData?.saleto?.pannumber && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">PAN:</span>{" "}
                                    {globalData?.saleto?.pannumber || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.fssai && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">FASSI:</span>{" "}
                                    {globalData?.saleto?.fssai || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.cinnumber && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">CIN:</span>{" "}
                                    {globalData?.saleto?.cinnumber || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.referenceid && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="">Reference No:</span>{" "}
                                    {globalData?.saleto?.referenceid || ""}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <table
                            width="100%"
                            className="mt-0"
                            style={{ borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr className=" fw-bold">
                                <th
                                  className="force-style font-12 p-0 text-center"
                                  style={{
                                    width: "40px",

                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                                >
                                  {" "}
                                  #
                                </th>
                                <th
                                  className="force-style font-12 p-0 ps-1"
                                  style={{
                                    textAlign: "left",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                                >
                                  Item
                                </th>

                                <th
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "80px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style font-12 p-0 pe-1 "
                                  style={{
                                    width: "60px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                                >
                                  Qty
                                </th>
                                <th
                                  // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "90px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Taxable Val
                                </th>
                                <th
                                  // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "90px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  {" "}
                                  Tax Amt
                                </th>

                                <th
                                  // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "100px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            {globalData?.saleitems?.length > 0 && (
                              <tbody>
                                {globalData?.saleitems?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="font-12 align-top"
                                    style={{ height: "30px" }}
                                  >
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                                        textAlign: "center",
                                        borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        padding: "0 5px",
                                      }}
                                    >
                                      {item?.title}
                                      {item.hsnsac && (
                                        <div className="font-12">
                                          <span className="fw-medium">
                                            {" "}
                                            {item.imode === "SERVICE"
                                              ? "SAC:"
                                              : "HSN:"}
                                          </span>{" "}
                                          {item.hsnsac}
                                        </div>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.baseprice}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.quantity}
                                      <span className="font-11 ms-1">
                                        {(() => {
                                          const unitCode = item?.isSecondaryUnit
                                            ? item?.unitConfig
                                                ?.secondaryUnitCode
                                            : item?.unitConfig?.primaryUnitCode;

                                          // return unitCode !== "unit" ? unitCode : "";
                                          return unitCode || "";
                                        })()}
                                      </span>
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.lineTotalBasePrice}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.lineTotalTaxAmount}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.lineGrandTotal}
                                    </td>
                                  </tr>
                                ))}

                                {[
                                  ...Array(
                                    Math.max(
                                      0,
                                      5 - (globalData?.saleitems?.length || 0),
                                    ),
                                  ),
                                ].map((_, i) => (
                                  <tr
                                    key={`empty-${i}`}
                                    style={{ height: "50px" }}
                                  >
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                            <tfoot
                              style={{
                                borderTop: `2px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <tr className="font-11">
                                <td
                                  colSpan="5"
                                  style={{
                                    padding: "5px",
                                    verticalAlign: "top",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <span className="fw-bold">In Words:</span>{" "}
                                  {globalData?.amountinwords}
                                </td>

                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "0",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div
                                    className="d-flex justify-content-between p-0 px-2  font-12"
                                    style={{
                                      borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    <span>Total</span>
                                    <span className="">
                                      ₹{globalData?.grandtotal}
                                    </span>
                                  </div>
                                  {!isInterState ? (
                                    <>
                                      <div
                                        className="d-flex justify-content-between p-0 px-2  font-12"
                                        style={{
                                          borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        }}
                                      >
                                        <span>CGST</span>
                                        <span className="">
                                          ₹{globalData?.cgstamount || 0}
                                        </span>
                                      </div>
                                      <div className="d-flex justify-content-between p-0 px-2 font-12">
                                        <span>SGST</span>
                                        <span className="">
                                          ₹{globalData?.sgstamount || 0}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="d-flex justify-content-between p-0 px-2 font-12 ">
                                      <span>IGST</span>
                                      <span className="">
                                        ₹{globalData?.igstamount || 0}
                                      </span>
                                    </div>
                                  )}
                                </td>
                              </tr>

                              {/* ROW 2: PAYMENT STATUS & SIGNATURE */}
                              <tr className="font-12">
                                {/* Left Side: Payment Methods (Cash/UPI/Card) */}
                                <td
                                  colSpan="5"
                                  style={{
                                    padding: "0px",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {optData?.isPayment && (
                                    <div className="row g-2 m-0">
                                      {globalData?.cashPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.cashPaid}</b> Paid
                                            via Cash
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.upiPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.upiPaid}</b> Paid
                                            via UPI
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.cardPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.cardPaid}</b> Paid
                                            via Card
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.onlinePaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.onlinePaid}</b> Paid
                                            via Online
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </td>

                                {/* Right Side Stack: Payment Summary */}
                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "0",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div
                                    className="d-flex justify-content-between p-0 px-2 border-bottom "
                                    style={{
                                      backgroundColor:
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                    }}
                                  >
                                    <span
                                      className="fw-bold font-12 "
                                      style={{
                                        color:
                                          selectedTheme?.templateTheme
                                            ?.foregroundColor,
                                      }}
                                    >
                                      Amount Payable
                                    </span>
                                    <span
                                      className="fw-bold font-12 "
                                      style={{
                                        color:
                                          selectedTheme?.templateTheme
                                            ?.foregroundColor,
                                      }}
                                    >
                                      ₹{globalData?.balanceDue || 0}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between p-0 px-2">
                                    <span className="font-12">Amount Paid</span>
                                    <span className="font-12 ">
                                      ₹
                                      {parseFloat(
                                        actualPaidAmount || 0,
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                          <div className="row mt-2">
                            <div className="col-4 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}
                            <div className="col-4  ms-auto">
                              <div className="text-end p-0 fw-bold font-12 mt-2 ">
                                {globalData?.salefrom?.title}
                              </div>
                              <div>
                                {storeSettings?.invoiceSettings?.signature ? (
                                  <div className="text-end p-0 fw-bold pb-1">
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings?.invoiceSettings
                                          ?.signature
                                      }
                                      width={100}
                                    />
                                  </div>
                                ) : (
                                  <div className="p-0 pt-4">
                                    <hr
                                      className="m-1 ms-auto "
                                      style={{
                                        border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        maxWidth: "120px",
                                      }}
                                    />
                                  </div>
                                )}
                                <div className="text-end p-0 font-12">
                                  Authorized Signatory
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              {optData?.isRemark && globalData?.remark && (
                                <table width="100%" className="mb-2">
                                  <tbody>
                                    <tr>
                                      <td width="100%">
                                        <div className="font-12 fw-600 align-left text-black mb-1">
                                          Remark
                                        </div>

                                        <div
                                          className="font-12 p-0"
                                          style={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            minHeight: "30px",
                                          }}
                                        >
                                          {capitalizeFirstLetter(
                                            globalData?.remark,
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                            </div>

                            <div className="col-12 ">
                              {terms?.length > 0 && (
                                <table width="100%">
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          padding: "0px",
                                        }}
                                        width="100%"
                                      >
                                        <div
                                          className="font-12 fw-600"
                                          style={{
                                            textAlign: "left",
                                            color: "black",
                                          }}
                                        >
                                          Terms & Conditions
                                        </div>
                                        <div className="terms-box font-12">
                                          {terms}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-2 font-11 d-flex justify-content-left ">
                                <span>
                                  Powered By{" "}
                                  <span className="fw-bold">NegoBill.com</span>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : globalData.salemode === "BILL" ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-3">
                          <div className="d-flex pb-1">
                            <div style={{ maxWidth: "16rem" }}>
                              <div>
                                {globalData?.salefrom?.image && (
                                  <img
                                    src={
                                      uRLs.IMAGE_URL +
                                      "profile/" +
                                      globalData?.salefrom?.image
                                    }
                                    className="img-rounded logo mb-0 obj-contain"
                                    height="45"
                                    width="100"
                                  />
                                )}
                              </div>

                              <div className="font-12">
                                {globalData?.salefrom?.addressline1}{" "}
                                {globalData?.salefrom?.addressline2}
                              </div>
                              <div className="font-12">
                                {globalData?.salefrom?.district}{" "}
                                {globalData?.salefrom?.state || ""}{" "}
                                {globalData?.salefrom?.pincode || ""}
                              </div>
                              <div className="font-12">
                                <span className="fw-bold">Ph:</span>{" "}
                                {globalData?.salefrom?.phone}{" "}
                              </div>
                            </div>

                            <div
                              style={{
                                flex: "1",
                                textAlign: "center",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "10px",
                                  color: "#555",
                                }}
                              >
                                BILL RECEIPT
                              </div>
                              <div
                                className="font012 mt-0"
                                style={{
                                  fontWeight: "800",
                                  textTransform: "uppercase",
                                  lineHeight: "1",
                                }}
                              >
                                {globalData?.salefrom?.title || "COMPANY NAME"}
                              </div>
                            </div>

                            <div
                              style={{
                                flex: "1",
                                textAlign: "right",
                              }}
                            >
                              <div
                                style={{
                                  display: "inline-block",
                                  textAlign: "right",
                                }}
                              >
                                <div
                                  className=" font-12 mb-0"
                                  style={{
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Bill No.
                                  <span className="fw-bold">
                                    {" "}
                                    {globalData?.saleno}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-end font-12">
                                  {/* <span>DATE: {saleTime?.date}</span> */}
                                  <span> DATE: {saleTime?.date}</span>
                                  <span className="ms-3">
                                    TIME:{saleTime?.time}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {globalData?.saleto && optData.isCustomerDisplay && (
                            <div
                              className="d-flex "
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                style={{
                                  flex: "1",
                                  padding: "5px",
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <span className="fw-bold font-12">
                                  Customer Details :
                                </span>
                                <div className="font-12 ">
                                  {globalData?.saleto?.name}
                                </div>
                                <div className="font-12">
                                  {" "}
                                  {globalData?.saleto?.addressline1 &&
                                    `${globalData?.saleto?.addressline1}, `}
                                  {globalData?.saleto?.addressline2 &&
                                    `${globalData?.saleto?.addressline2}, `}
                                  {globalData?.saleto?.district &&
                                    `${globalData?.saleto?.district}, `}
                                  {globalData?.saleto?.pincode &&
                                    ` - ${globalData?.saleto?.pincode}`}
                                </div>
                              </div>
                              {(globalData?.saleto?.shippingAddress
                                ?.addressline1 ||
                                globalData?.saleto?.shippingAddress
                                  ?.addressline1) && (
                                <div
                                  style={{
                                    flex: "1",
                                    padding: "5px",
                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <span className="fw-bold font-12">
                                    shipping Details:
                                  </span>
                                  <div className="font-12">
                                    {" "}
                                    {globalData?.saleto?.shippingAddress
                                      ?.addressline1 &&
                                      `${globalData?.saleto?.shippingAddress?.addressline1}, `}
                                    {globalData?.saleto?.shippingAddress
                                      ?.addressline2 &&
                                      `${globalData?.saleto?.shippingAddress?.addressline2}, `}
                                    {globalData?.saleto?.shippingAddress
                                      ?.district &&
                                      `${globalData?.saleto?.shippingAddress?.district}, `}
                                    {globalData?.saleto?.shippingAddress
                                      ?.pincode &&
                                      ` - ${globalData?.saleto?.shippingAddress?.pincode}`}
                                  </div>
                                </div>
                              )}
                              <div
                                style={{
                                  width: "180px",
                                  padding: "5px",
                                  WebkitFontSmoothing: "antialiased",
                                  textRendering: "optimizeLegibility",
                                }}
                              >
                                <div className="font-12">
                                  <span className="fw-bold">Ph:</span>{" "}
                                  {globalData?.saleto?.phone || ""}
                                </div>
                                <div className=" font-12">
                                  {" "}
                                  <span className="fw-bold">GSTIN:</span>{" "}
                                  {globalData?.saleto?.gstnumber || ""}
                                </div>
                                {globalData?.saleto?.pannumber && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">PAN:</span>{" "}
                                    {globalData?.saleto?.pannumber || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.fssai && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">FASSI:</span>{" "}
                                    {globalData?.saleto?.fssai || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.cinnumber && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="fw-bold">CIN:</span>{" "}
                                    {globalData?.saleto?.cinnumber || ""}
                                  </div>
                                )}
                                {globalData?.saleto?.referenceid && (
                                  <div className=" font-12">
                                    {" "}
                                    <span className="">Reference No:</span>{" "}
                                    {globalData?.saleto?.referenceid || ""}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <table
                            width="100%"
                            className="mt-0"
                            style={{ borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr className=" fw-bold">
                                <th
                                  className="force-style font-12 p-0 text-center"
                                  style={{
                                    width: "40px",

                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                                >
                                  {" "}
                                  #
                                </th>
                                <th
                                  className="force-style font-12 p-0 ps-1"
                                  style={{
                                    textAlign: "left",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                                >
                                  Item
                                </th>

                                <th
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "100px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style font-12 p-0 pe-1 "
                                  style={{
                                    width: "60px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                                >
                                  Qty
                                </th>
                                <th
                                  // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                                  className="force-style font-12 p-0 pe-1"
                                  style={{
                                    width: "100px",
                                    textAlign: "right",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            {globalData?.saleitems?.length > 0 && (
                              <tbody>
                                {globalData?.saleitems?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="font-12 align-top"
                                    style={{ height: "30px" }}
                                  >
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                                        textAlign: "center",
                                        borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        padding: "0 5px",
                                      }}
                                    >
                                      {item?.title}
                                      {item.hsnsac && (
                                        <div className="font-12">
                                          <span className="fw-medium">
                                            {" "}
                                            {item.imode === "SERVICE"
                                              ? "SAC:"
                                              : "HSN:"}
                                          </span>{" "}
                                          {item.hsnsac}
                                        </div>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.baseprice}
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.quantity}
                                      <span className="font-11 ms-1">
                                        {(() => {
                                          const unitCode = item?.isSecondaryUnit
                                            ? item?.unitConfig
                                                ?.secondaryUnitCode
                                            : item?.unitConfig?.primaryUnitCode;

                                          // return unitCode !== "unit" ? unitCode : "";
                                          return unitCode || "";
                                        })()}
                                      </span>
                                    </td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        textAlign: "right",
                                        paddingRight: "5px",
                                      }}
                                    >
                                      ₹{item?.lineGrandTotal}
                                    </td>
                                  </tr>
                                ))}

                                {[
                                  ...Array(
                                    Math.max(
                                      0,
                                      5 - (globalData?.saleitems?.length || 0),
                                    ),
                                  ),
                                ].map((_, i) => (
                                  <tr
                                    key={`empty-${i}`}
                                    style={{ height: "50px" }}
                                  >
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    ></td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                            <tfoot
                              style={{
                                borderTop: `2px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <tr className="font-11">
                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "1px",
                                    verticalAlign: "top",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <span className="fw-bold ps-1 font-12">
                                    In Words:
                                  </span>{" "}
                                  {globalData?.amountinwords}
                                </td>

                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "0",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div className="d-flex justify-content-between p-0 px-2  font-12">
                                    <span>Total</span>
                                    <span className="">
                                      ₹{globalData?.grandtotal}
                                    </span>
                                  </div>
                                </td>
                              </tr>

                              {/* ROW 2: PAYMENT STATUS & SIGNATURE */}
                              <tr className="font-12">
                                {/* Left Side: Payment Methods (Cash/UPI/Card) */}
                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "0px",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {" "}
                                  {optData?.isPayment && (
                                    <div className="row g-2 m-0">
                                      {globalData?.cashPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.cashPaid}</b> Paid
                                            via Cash
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.upiPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.upiPaid}</b> Paid
                                            via UPI
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.cardPaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.cardPaid}</b> Paid
                                            via Card
                                          </span>
                                        </div>
                                      )}
                                      {globalData?.onlinePaid > 0 && (
                                        <div className="col-6 font-12 ps-1">
                                          <span>
                                            <b>₹{globalData.onlinePaid}</b> Paid
                                            via Online
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </td>

                                {/* Right Side Stack: Payment Summary */}
                                <td
                                  colSpan="3"
                                  style={{
                                    padding: "0",
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div
                                    className="d-flex justify-content-between p-0 px-2  "
                                    style={{
                                      backgroundColor: `${
                                        selectedTheme?.templateTheme
                                          ?.primaryColor
                                      }`,
                                    }}
                                  >
                                    <span
                                      className="fw-bold font-12 "
                                      style={{
                                        color:
                                          selectedTheme?.templateTheme
                                            ?.foregroundColor,
                                      }}
                                    >
                                      Amount Payable
                                    </span>
                                    <span
                                      className="fw-bold font-12 "
                                      style={{
                                        color:
                                          selectedTheme?.templateTheme
                                            ?.foregroundColor,
                                      }}
                                    >
                                      ₹{globalData?.balanceDue || 0}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between p-0 px-2">
                                    <span className="font-12">Amount Paid</span>
                                    <span className="font-12 ">
                                      ₹
                                      {parseFloat(
                                        actualPaidAmount || 0,
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                          <div className="row mt-2">
                            <div className="col-4 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}

                            <div className="col-5  ms-auto">
                              <div className="text-end p-0 fw-bold font-12 mt-2 ">
                                {globalData?.salefrom?.title}
                              </div>
                              <div>
                                {storeSettings?.invoiceSettings?.signature ? (
                                  <div className="text-end p-0 fw-bold pb-1">
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings?.invoiceSettings
                                          ?.signature
                                      }
                                      width={100}
                                    />
                                  </div>
                                ) : (
                                  <div className="p-0 pt-4">
                                    <hr
                                      className="m-1 ms-auto "
                                      style={{
                                        border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        maxWidth: "120px",
                                      }}
                                    />
                                  </div>
                                )}
                                <div className="text-end p-0 font-12">
                                  Authorized Signatory
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              {optData?.isRemark && globalData?.remark && (
                                <table width="100%" className="mb-2">
                                  <tbody>
                                    <tr>
                                      <td width="100%">
                                        <div className="font-12 fw-600 align-left text-black mb-1">
                                          Remark
                                        </div>

                                        <div
                                          className="font-12 p-0"
                                          style={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            minHeight: "30px",
                                          }}
                                        >
                                          {capitalizeFirstLetter(
                                            globalData?.remark,
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                            </div>
                            <div className="col-12 ">
                              {terms?.length > 0 && (
                                <table width="100%">
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          padding: "0px",
                                        }}
                                        width="100%"
                                      >
                                        <div
                                          className="font-12 fw-600"
                                          style={{
                                            textAlign: "left",
                                            color: "black",
                                          }}
                                        >
                                          Terms & Conditions
                                        </div>
                                        <div className="terms-box font-12">
                                          {terms}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-2 font-11 d-flex justify-content-left ">
                                <span>
                                  Powered By{" "}
                                  <span className="fw-bold">NegoBill.com</span>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="default-content">
                <p>No content available for this sale mode.</p>
              </div>
            )}
           
          </div>
        )}
        <InvoiceInfoSidebar
          {...invoiceData}
          isData={isData}
          handleSelectedReturnSale={handleSelectedReturnSale}
        />
      </InvoiceModalLayout>
      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}

      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default PrimeInvoice;
